export enum CalloutCaptcha {
  None = 'none',
  Guest = 'guest',
  All = 'all',
}
